import DtoInterface from "./DtoInterface";
import CustomerDto from "./CustomerDto";
import ProductDto from "./ProductDto";

export default class PixPaymentDto implements DtoInterface {
  public id?: number;
  public paymentId?: string;
  public customer?: CustomerDto;
  public product?: ProductDto;
  public amount?: number;
  public companyId?: string
  public pageId?: string

  public toJson(): object {
    return {
      customer: this.customer?.toJson(),
      product: this.product?.toJson(),
      amount: this.amount,
      company_id: this.companyId,
      page_id: this.pageId,
    }
  }

  public fromJson(json: any): void {
    this.paymentId = json.payment_id;
  }
}